import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/about/codeofconductbanner.webp";

const Cocmanagement = () => {
  return (
    <>
      <title>Code of Conduct | ISBM University Management Guidelines</title>
      <meta
        name="description"
        content="Discover ISBM University’s Management Code of Conduct, ensuring ethical leadership, transparency, and accountability in academic governance."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>CODE OF CONDUCT FOR UNIVERSITY MANAGEMENT</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Code of Conduct (Management)
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="coc-card shadow p-4 p-lg-5">
                <div className="intro-section mb-5">
                  <p className="lead">
                    A management code of conduct in a University portrays the
                    anticipated conduct, obligations, values and moral criteria
                    the management of the university authorities are expected to
                    follow.
                  </p>
                </div>

                {/* Commitment to Mission and Vision */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-target me-2"></i>
                    Commitment to Mission and Vision
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Demonstrate strong dedication to maintain the goal,
                      vision, mission and values of the university
                    </li>
                    <li>
                      Uphold ideals of academic superiority, honesty, social
                      inclusiveness, and public service
                    </li>
                    <li>
                      Align all decisions and policies with the university's
                      core principles
                    </li>
                  </ul>
                </div>

                {/* Ethical Behaviour */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-shield-check me-2"></i>
                    Ethical Behaviour
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Exhibit honesty, integrity, and transparency in all
                      activities and decisions
                    </li>
                    <li>
                      Avoid any conflicts of interest and prioritize the
                      university's best interests
                    </li>
                    <li>Maintain impartiality and fairness in all dealings</li>
                  </ul>
                </div>

                {/* Compliance with Laws and Regulations */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-scale me-2"></i>
                    Compliance with Laws and Regulations
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Adhere to all relevant rules, regulations, and policies
                      governing higher education
                    </li>
                    <li>
                      Ensure compliance with academic standards, financial
                      management, and equal opportunity policies
                    </li>
                    <li>
                      Stay updated with changing legal and regulatory
                      requirements
                    </li>
                  </ul>
                </div>

                {/* Respect for Diversity and Inclusion */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-heart-handshake me-2"></i>
                    Respect for Diversity and Inclusion
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Foster a diverse, inclusive, and dignified atmosphere
                    </li>
                    <li>
                      Appreciate contributions from all individuals regardless
                      of race, ethnicity, gender, religion, sexual orientation,
                      or disability
                    </li>
                    <li>
                      Implement policies that promote equal opportunity and
                      prevent discrimination
                    </li>
                  </ul>
                </div>

                {/* Professionalism and Collegiality */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-users me-2"></i>
                    Professionalism and Collegiality
                  </h3>
                  <ul className="conduct-items">
                    <li>Demonstrate appropriate behaviour at all times</li>
                    <li>
                      Cultivate collegial relationships with faculty, staff,
                      students, and stakeholders
                    </li>
                    <li>
                      Encourage collaboration, teamwork, and mutual respect
                    </li>
                  </ul>
                </div>

                {/* Resource Stewardship */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-pig-money me-2"></i>
                    Resource Stewardship
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Responsibly manage university resources including
                      finances, personnel, and physical assets
                    </li>
                    <li>
                      Ensure efficient and effective utilization to achieve
                      strategic objectives
                    </li>
                    <li>
                      Implement sustainable practices for long-term
                      institutional health
                    </li>
                  </ul>
                </div>

                {/* Accountability and Transparency */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-checklist me-2"></i>
                    Accountability and Transparency
                  </h3>
                  <ul className="conduct-items">
                    <li>Take responsibility for actions and decisions</li>
                    <li>
                      Maintain clear communication and proper documentation
                    </li>
                    <li>
                      Provide justification for significant decisions when
                      appropriate
                    </li>
                  </ul>
                </div>

                {/* Confidentiality and Privacy */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-lock me-2"></i>
                    Confidentiality and Privacy
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Protect sensitive information including student records
                      and personnel matters
                    </li>
                    <li>
                      Disclose confidential information only when necessary and
                      authorized
                    </li>
                    <li>Comply with all data protection regulations</li>
                  </ul>
                </div>

                {/* Conflict Management */}
                <div className="conduct-section mb-5">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-peace me-2"></i>
                    Conflict Management
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Prevent and resolve conflicts in a constructive and fair
                      manner
                    </li>
                    <li>
                      Promote transparent communication and reconciliation
                    </li>
                    <li>Implement fair grievance redressal mechanisms</li>
                  </ul>
                </div>

                {/* Continuous Improvement */}
                <div className="conduct-section">
                  <h3 className="fw-bold text-blue mb-4">
                    <i className="ti ti-trending-up me-2"></i>
                    Continuous Improvement
                  </h3>
                  <ul className="conduct-items">
                    <li>
                      Pursue professional development and learning opportunities
                    </li>
                    <li>
                      Stay updated with effective methods in higher education
                      administration
                    </li>
                    <li>
                      Adapt to changing circumstances and emerging best
                      practices
                    </li>
                  </ul>
                </div>

                {/* Note Section */}
                <div className="note-section mt-5 pt-4 border-top">
                  <h4 className="fw-bold text-blue">Note:</h4>
                  <p>
                    Universities must perform regular reviews and updates of
                    their code of conduct for management to ensure that it
                    remains relevant and effective in fostering ethical
                    behaviour and maintaining institutional integrity. In
                    addition, training and support programmes may be offered to
                    assist management professionals in comprehending and
                    adhering to the concepts portrayed in the code of conduct.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Cocmanagement;
